import { render, staticRenderFns } from "./WoerterFinden.vue?vue&type=template&id=c9e30472"
import script from "./WoerterFinden.vue?vue&type=script&lang=ts"
export * from "./WoerterFinden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports